import { ReactNode } from 'react';
import { AdminTableProvider } from './AdminTable';
import { Button } from '@platform/components';

/**
 * Wrapper for admin pages that display data listed in AdminTable component. Provides basic template as well as AdminTableContext provider
 */
export const AdminListPageWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <AdminTableProvider>
      <div className='flex flex-col justify-center gap-6 px-2'>
        <div className='w-full flex flex-col gap-4'>{children}</div>
      </div>
    </AdminTableProvider>
  );
};

export type AdminActionsButtonProps =
  | {
      type: 'button';
      text: string;
      onPress: () => void;
      isDisabled?: boolean;
      linkColor?: 'blue' | 'red';
    }
  | {
      type: 'link';
      text: string;
      href: string;
      isDisabled?: boolean;
      linkColor?: 'blue' | 'red';
    };

export const AdminActionsButton = (props: AdminActionsButtonProps) => {
  const { type, text, linkColor = 'blue' } = props;
  if (type === 'button') {
    return (
      <Button
        onPress={props.onPress}
        variant='link-color'
        additionalClassnames={`w-fit ${linkColor === 'red' ? 'text-red-600' : ''}`}
        size='sm'
        isDisabled={props.isDisabled}
      >
        {text}
      </Button>
    );
  } else {
    return (
      <Button
        href={props.href}
        variant='link-color'
        additionalClassnames={`w-fit ${linkColor === 'red' ? 'text-red-600' : ''}`}
        size='sm'
        isDisabled={props.isDisabled}
      >
        {text}
      </Button>
    );
  }
};

export const AdminActionsContainer = ({ actions }: { actions: AdminActionsButtonProps[] }) => {
  return (
    <div className='flex flex-col'>
      {actions.map((action) => (
        <AdminActionsButton key={action.text} {...action} />
      ))}
    </div>
  );
};
